var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckPink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1284 3.64303C14.3887 3.90338 14.3887 4.32549 14.1284 4.58584L6.63305 12.0812C6.34667 12.3676 5.88235 12.3676 5.59596 12.0812L1.87187 8.35708C1.61152 8.09673 1.61152 7.67462 1.87187 7.41427C2.13222 7.15392 2.55432 7.15392 2.81467 7.41427L6.11451 10.7141L13.1856 3.64303C13.4459 3.38268 13.868 3.38268 14.1284 3.64303Z",
    fill: "#A459B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPink);
export default __webpack_public_path__ + "static/media/check_pink.2ad0cfb4c13ccd3dd945d5cda5a7aff1.svg";
export { ForwardRef as ReactComponent };